import script from "./icon-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./icon-menu.vue?vue&type=script&setup=true&lang=ts"

import "./icon-menu.vue?vue&type=style&index=0&id=49d0eac9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49d0eac9"]])

export default __exports__